import { alpha, type SxProps, type Theme } from "@mui/material/styles";
import { BRAND_COLOR } from "@kivunova/kivufrontendcommon";

export const CATEGORY_INDENT_PX = 28;
export const CATEGORY_ROOT_INDENT_PX = 8;
export const CATEGORY_MOBILE_INDENT_PX = 14;
export const CATEGORY_MOBILE_ROOT_INDENT_PX = 4;

export const categoryTableContainerSx: SxProps<Theme> = {
  borderRadius: 2,
  border: "1px solid",
  borderColor: "divider",
  overflow: "auto",
  boxShadow: "none",
  maxWidth: "100%",
  backgroundColor: "background.paper"
};

export const categoryTableHeadRowSx: SxProps<Theme> = {
  backgroundColor: alpha(BRAND_COLOR, 0.04),
  "& .MuiTableCell-head": {
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: "0.02em",
    textTransform: "uppercase",
    color: "text.secondary",
    borderBottom: `2px solid ${alpha(BRAND_COLOR, 0.12)}`,
    py: 1.5,
    backgroundColor: alpha(BRAND_COLOR, 0.04)
  }
};

export const categoryTableHeadSortSx: SxProps<Theme> = {
  "& .MuiTableSortLabel-root": {
    color: "text.secondary",
    "&:hover": { color: BRAND_COLOR },
    "&.Mui-active": { color: BRAND_COLOR }
  },
  "& .MuiTableSortLabel-icon": {
    color: `${BRAND_COLOR} !important`
  }
};

export const getCategoryRowSx = (
  _level: number,
  isExpanded: boolean
): SxProps<Theme> => ({
  backgroundColor: "background.paper",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: alpha(BRAND_COLOR, 0.04)
  },
  ...(isExpanded && {
    backgroundColor: alpha(BRAND_COLOR, 0.02)
  })
});

export const categoryExpandButtonSx = (isMobile = false): SxProps<Theme> => ({
  width: isMobile ? 24 : 28,
  height: isMobile ? 24 : 28,
  mr: 0.5,
  color: BRAND_COLOR,
  border: `1px solid ${alpha(BRAND_COLOR, 0.2)}`,
  borderRadius: 1,
  backgroundColor: alpha(BRAND_COLOR, 0.06),
  "&:hover": {
    backgroundColor: alpha(BRAND_COLOR, 0.12),
    borderColor: alpha(BRAND_COLOR, 0.35)
  }
});

export const categoryFolderIconSx = (
  level: number,
  isMobile = false
): SxProps<Theme> => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: isMobile ? 26 : 32,
  height: isMobile ? 26 : 32,
  borderRadius: 1,
  mr: isMobile ? 0.75 : 1.25,
  flexShrink: 0,
  color: BRAND_COLOR,
  backgroundColor:
    level === 0 ? alpha(BRAND_COLOR, 0.1) : alpha(BRAND_COLOR, 0.06)
});

export const categoryChildCountChipSx: SxProps<Theme> = {
  height: 22,
  fontSize: 11,
  fontWeight: 600,
  backgroundColor: alpha(BRAND_COLOR, 0.1),
  color: BRAND_COLOR,
  border: `1px solid ${alpha(BRAND_COLOR, 0.15)}`
};

export const categoryLevelChipSx: SxProps<Theme> = {
  height: 22,
  fontSize: 11,
  fontWeight: 600,
  backgroundColor: alpha(BRAND_COLOR, 0.08),
  color: BRAND_COLOR
};

export const categoryPathSx: SxProps<Theme> = {
  fontSize: 11,
  mt: 0.35,
  color: "text.secondary",
  lineHeight: 1.4
};

export const categoryProductCountSx: SxProps<Theme> = {
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  minWidth: 28,
  height: 26,
  px: 1,
  borderRadius: 1,
  fontSize: 13,
  fontWeight: 600,
  color: BRAND_COLOR,
  backgroundColor: alpha(BRAND_COLOR, 0.08)
};

export const categoryActionsButtonSx = (isOpen: boolean): SxProps<Theme> => ({
  backgroundColor: isOpen ? alpha(BRAND_COLOR, 0.1) : "transparent",
  color: isOpen ? BRAND_COLOR : "text.secondary",
  "&:hover": {
    backgroundColor: alpha(BRAND_COLOR, 0.08),
    color: BRAND_COLOR
  }
});

export const categoryNameIndentSx = (
  level: number,
  isMobile = false
): SxProps<Theme> => ({
  pl: `${
    (isMobile ? CATEGORY_MOBILE_ROOT_INDENT_PX : CATEGORY_ROOT_INDENT_PX) +
    level * (isMobile ? CATEGORY_MOBILE_INDENT_PX : CATEGORY_INDENT_PX)
  }px`,
  display: "flex",
  alignItems: "center",
  minWidth: 0
});

export const categoryMobileMetaSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 0.75,
  mt: 0.5
};
